/**
 * EducatorRoute - Wrapper component for educator-only routes.
 *
 * Redirects non-educators (not a coach/admin/org-staff) to the dashboard, so the educator surfaces
 * are unreachable by role even if a feature flag was enabled for the account. This is a coarse
 * defense-in-depth gate matching the sidebar's `isEducator` predicate; the authoritative per-cohort
 * authorization (which also covers class instructors) is enforced independently by the server.
 *
 * These routes render only inside the authenticated Layout (App.jsx gates on `user`), so `user` is
 * always populated here - no loading state is needed.
 */

import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import { isEducator } from '../utils/roles'

const EducatorRoute = ({ children, fallbackPath = '/dashboard' }) => {
  const user = useAuthStore((state) => state.user)

  if (!isEducator(user)) {
    return <Navigate to={fallbackPath} replace />
  }

  return children
}

export default EducatorRoute
